import api from '../utils/api';
import { submitAndPollTextImprovement } from '../utils/pollTextImprovementJob';

export async function listPromptTemplates(params = {}) {
  const { data } = await api.get('/prompt-templates/', { params });
  return data;
}

export async function getPromptTemplate(slug) {
  const { data } = await api.get(`/prompt-templates/${encodeURIComponent(slug)}`);
  return data;
}

export async function createPromptTemplate(payload) {
  const { data } = await api.post('/prompt-templates/', payload);
  return data;
}

export async function updatePromptTemplate(slug, payload) {
  const { data } = await api.put(`/prompt-templates/${encodeURIComponent(slug)}`, payload);
  return data;
}

export async function deletePromptTemplate(slug) {
  const { data } = await api.delete(`/prompt-templates/${encodeURIComponent(slug)}`);
  return data;
}

export async function improvePromptTemplateContent(slug, { text, userConsiderations }) {
  return submitAndPollTextImprovement(() =>
    api.post(`/prompt-templates/${encodeURIComponent(slug)}/improve-content`, {
      text,
      user_considerations: userConsiderations || undefined,
    })
  );
}
